import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Row, FormFeedback, Input } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { Link } from 'react-router-dom'

import { setCampaignData } from 'redux/actions/marketing'
import { SelectWithLabel } from 'components/Form'
import FacebookAdditionalFields from './FacebookAdditionalFields'
import ModalTemplate from './ModalTemplate'
import PhoneViewer from 'components/PhoneViewer'
import Nixi1Spinner from 'components/Nixi1Spinner'

const Step3View = ({ info, isFetching, currentTemplate, company, variables, options, templates, dispatch, campaign, error }) => {
  //const [phoneTextPreview, setPhoneTextPreview] = useState('')
  const channelInfo = (() => {
    if (info.channel === 'Messenger') return 'facebook'
    if (info.provider && info.provider === 'whatsapp') return 'whatsapp_whatsapp'
    return info.channel.toLowerCase()
  })()
  const [textPreview, setTextPreview] = useState({})

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [currentValue, setCurrentValue] = useState(null)

  useEffect(() => {
    selectTemplate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign, templates])

  const selectTemplate = () => {
    const templatesCamapaign = campaign.templates.find((t) => t.channel === currentTemplate)
    if (templatesCamapaign) {
      setCurrentValue(options.find((op) => op.value === templatesCamapaign.templateId))
      const template = templates.find((t) => t._id === templatesCamapaign.templateId)
      setTextPreview({ ...template })
    }
  }

  const handleSelectChange = (result) => {
    if (info.provider) {
      if (info.provider === 'whatsapp') info.channel = 'whatsapp_whatsapp'
    }

    const template = templates.find((t) => t._id === result.value)
    setTextPreview({ ...template })
    const templatesRedux = campaign.templates.filter((elem) => elem.channel !== info.channel)

    // only one template per channel
    const channelTemplateExists = templatesRedux.find((el) => el.channel === channelInfo)

    if (!channelTemplateExists) {
      const channel = info.provider ? info.channel : template.channel
      templatesRedux.push({ channel , templateId: result.value })
      dispatch(setCampaignData({ ...campaign, templates: templatesRedux }))
    } else {
      // change oldTemplate for newTemplate
      templatesRedux.forEach((el) => {
        if (el.channel === channelInfo) {
          el.templateId = result.value
        }
        return el
      })
      dispatch(setCampaignData({ ...campaign, templates: templatesRedux }))
    }

    // const contentStr = template.variables.reduce(
    //   (a, c) => a.replaceAll(c.name, variables.find((v) => v.value === c.field).example.text),
    //   template.content
    // )

    // const buttonsStr = template.buttons
    //   .map(
    //     (b) => `
    //     ${b.label}:
    //     ${b.content}
    //     `
    //   )
    //   .join(' ')

    // setPhoneTextPreview(
    //   `${contentStr}
    //   ${buttonsStr}`
    // )

    if (currentTemplate === 'whatsapp') {
      setIsOpenModal(true)
    }
  }

  return (
    <Row className='my-3 overflow-hidden'>
      <Col sm={12} xs={12} xl={7} className='mb-4 template'>
        <h3>{info.name}</h3>
        <p>{I18n.t('campaign_messages_template_notice', { channel: info.channel })}</p>
        {isFetching && <Nixi1Spinner width='25px' height='25px' />}

        {/* <Label for='template'>{I18n.t('dashboard_template')}</Label> */}
        {/* <Select
          name='template'
          id='template'
          options={options}
          onChange={(value) => handleSelectChange(value)}
          styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW} /> */}
        <SelectWithLabel
          name='template'
          id='template'
          label={I18n.t('dashboard_template')}
          placeholder={I18n.t('dashboard_choose-template')}
          options={options}
          value={currentValue}
          onChange={(value) => handleSelectChange(value)}
        />

        <Link
          to={`/dashboard/marketing/templates?formTemplate=${channelInfo}`}
          className='hint'
        >
          <div className='img-wrapper'>
            <img src='./img/icons/icon-arrow-right-up.svg' alt='hint' />
          </div>
          <p className="hint-text">{I18n.t('dashboard_create-modify-templates-in-section')}</p>
        </Link>

        {/* Only for facebook */}
        {channelInfo === 'facebook' && (
          <>
            <FacebookAdditionalFields error={error} />
            <Input type='text' hidden={true} invalid={!!error['facebookObject']} />
            <FormFeedback>{error['facebookObject']}</FormFeedback>
          </>
        )}
      </Col>

      <PhoneViewer variables={variables} channel={currentTemplate} company={company} textPreview={textPreview} origin='marketing' />

      {/* <Col sm={12} xs={12} xl={5} className='phone-background align-items-end align-text-bottom pb-0 mb-0'>
        <img className='phone1' src='img/phone.png' alt='' width='270px' />
        <img className='phone2' src={`img/phone-${currentTemplate.toLowerCase()}.png`} alt='' width='248px' />
        {variables.length && (
          <>
            <img className={`company ${currentTemplate}`} src={company.icon} alt={company.text} />
            <img className='company' src={company.icon} alt={company.text} />
          </>
        )}
        {phoneTextPreview && (
          <div className='rectangle'>
            <p>{phoneTextPreview}</p>
          </div>
        )}
      </Col> */}
      <ModalTemplate isOpenModal={isOpenModal} setIsOpenModal={setIsOpenModal} />
    </Row>
  )
}

export default connect((store) => ({
  campaign: store.marketing.campaign,
}))(Step3View)
